import pristine from 'pristinejs';

export function forms() {
    const forms = document.querySelectorAll('[data-validate]');

    let defaultConfig = {
        // https://pristine.js.org/
        // class of the parent element where the error/success class is added
        classTo: 'input',
        errorClass: 'has-error',
        successClass: 'has-success',
        // class of the parent element where error text element is appended
        errorTextParent: 'messages',
        // type of element to create for the error text
        errorTextTag: 'p',
        // class of the error text element
        errorTextClass: 'error',
    };

    forms.forEach(function (form) {
        const formValidation = new pristine(form, defaultConfig);
        const formSuccess = form.querySelector('[data-validate_success]');
        const formBody = form.querySelector('[data-validate_body]');

        // pristine.addMessages('ru', {
        //     required: 'Это обязательное поле'
        // });

        // pristine.setLocale("ru");

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            // check if the form is valid
            var valid = formValidation.validate(); // returns true or false
            console.log(valid);
            if (valid && formSuccess && formBody) {
                formBody.classList.add('hidden'); //hide form body
                formSuccess.classList.add('_active'); // show success message
            }
        });
    });
}
